// 46985 owner: the invoice creator's SALE FEES, one line per fee (date, nature/bucket + description, charged on the order, share on THIS
// invoice, recognised/billed state), then "Remaining per fee" styled like the payment schedule (charged, on this invoice, billed on other
// invoices, remaining to bill; the due rule under the fee name). Figures from GET /invoicing `fees` (API 46985) through feeRows (exact cents); a fee with no ledger
// leg yet (delivery-clocked, not recognised) is shown as such, never dropped. Read-only.
import React from 'react';
import { formatDate, formatMoneyExact } from '../../../utils/format';
import { feeRows, feeDueRule, FEE_STATE_TONE, cents } from './invoicingModel.mjs';

const money = v => formatMoneyExact(v);

export default function InvoiceFeesSection({ fees, sel, draftId = null, t }) {
  if (!Array.isArray(fees) || !fees.length) return null;
  const { rows, totals } = feeRows(fees, sel, draftId);
  const nature = f => f.bucket || f.type_label || '—';
  const due = f => { const r = feeDueRule(f); return t(r.key, { n: r.n }); };
  return (<>
    <div className="sec-lab">{t('giFees')}</div>
    <div className="gtable-wrap wrap"><table className="gtable zebra" data-testid="inv-fees">
      <thead><tr><th>{t('fColDate')}</th><th>{t('fColNature')}</th><th className="r">{t('fColCharged')}</th><th className="r">{t('fColThis')}</th><th>{t('fColState')}</th></tr></thead>
      <tbody>{rows.map(f => (
        <tr key={f.fee_id} data-testid={`inv-fee-${f.fee_id}`}>
          <td style={{ whiteSpace: 'nowrap' }}>{f.date ? formatDate(f.date) : '—'}</td>
          <td>{nature(f)}{f.description && <span className="sub">{f.description}</span>}</td>
          <td className="r num">{money(f.charged)}</td>
          <td className="r num"><b>{money(f.this_invoice)}</b></td>
          <td><span className={`chip ${FEE_STATE_TONE[f.state]}`}>{t(`fs_${f.state}`)}</span>
            <span className="sub">{t('fRecognised', { amount: money(f.recognised) })}</span></td>
        </tr>))}</tbody>
      <tfoot><tr><td colSpan={2}>{t('fTotal')}</td><td className="r num">{money(totals.charged)}</td><td className="r num" data-testid="inv-fees-this">{money(totals.this_invoice)}</td><td /></tr></tfoot>
    </table></div>
    <div className="sec-lab">{t('fRemainingTitle')}</div>
    <div className="gtable-wrap wrap"><table className="gtable zebra" data-testid="inv-fees-remaining">
      <thead><tr><th>{t('fColFee')}</th><th className="r">{t('fColCharged')}</th><th className="r">{t('fColThis')}</th><th className="r">{t('fColOther')}</th><th className="r">{t('fColRemaining')}</th></tr></thead>
      <tbody>{rows.map(f => (
        <tr key={f.fee_id}>
          <td>{nature(f)}<span className="sub">{due(f)}</span></td>
          <td className="r num">{money(f.charged)}</td>
          <td className="r num">{money(f.this_invoice)}</td>
          <td className="r num">{money(f.other_invoices)}{f.invoice_nos.length > 0 && <span className="sub">{f.invoice_nos.join(', ')}</span>}</td>
          <td className="r num"><b>{money(f.remaining)}</b>{cents(f.not_recognised) > 0n && <span className="sub">{t('fNotRec', { amount: money(f.not_recognised) })}</span>}</td>
        </tr>))}</tbody>
      <tfoot><tr><td>{t('fTotal')}</td><td className="r num">{money(totals.charged)}</td><td className="r num">{money(totals.this_invoice)}</td><td className="r num">{money(totals.other_invoices)}</td><td className="r num" data-testid="inv-fees-remaining-total">{money(totals.remaining)}</td></tr></tfoot>
    </table></div>
    <div className="hint">{t('fHint')}</div>
  </>);
}
